var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, render } from 'lit';
import { property, query, queryAssignedElements, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ExpandableContainerLit } from '../popover/expandable-container.lit';
import { translate } from '../utilities/translate';
import styles from './sds-notification-toast.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-notification-toast` is a toast-style notification component for brief alerts,
 * with options for customization in type, timing, and heading.
 *
 * ### Attributes
 * - `date`: The date or timestamp associated with the notification.
 * - `type`: The type of notification, determining its appearance and purpose.
 * - `timeout`: Duration (in milliseconds) that the notification remains visible.
 * - `heading`: Main heading or title for the notification.
 *
 * @tag sds-notification-toast
 */
let SdsNotificationToast = (() => {
    var _SdsNotificationToast_date_accessor_storage, _SdsNotificationToast_type_accessor_storage, _SdsNotificationToast_timeout_accessor_storage, _SdsNotificationToast__messageContainer_accessor_storage, _SdsNotificationToast__renderToggle_accessor_storage, _SdsNotificationToast__bodyOverflows_accessor_storage, _SdsNotificationToast__footerSlot_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-notification-toast')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = ExpandableContainerLit;
    let _date_decorators;
    let _date_initializers = [];
    let _date_extraInitializers = [];
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _timeout_decorators;
    let _timeout_initializers = [];
    let _timeout_extraInitializers = [];
    let __messageContainer_decorators;
    let __messageContainer_initializers = [];
    let __messageContainer_extraInitializers = [];
    let __renderToggle_decorators;
    let __renderToggle_initializers = [];
    let __renderToggle_extraInitializers = [];
    let __bodyOverflows_decorators;
    let __bodyOverflows_initializers = [];
    let __bodyOverflows_extraInitializers = [];
    let __footerSlot_decorators;
    let __footerSlot_initializers = [];
    let __footerSlot_extraInitializers = [];
    var SdsNotificationToast = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsNotificationToast_date_accessor_storage.set(this, __runInitializers(this, _date_initializers, void 0));
            _SdsNotificationToast_type_accessor_storage.set(this, (__runInitializers(this, _date_extraInitializers), __runInitializers(this, _type_initializers, 'info')));
            _SdsNotificationToast_timeout_accessor_storage.set(this, (__runInitializers(this, _type_extraInitializers), __runInitializers(this, _timeout_initializers, void 0)));
            this._timer = __runInitializers(this, _timeout_extraInitializers);
            _SdsNotificationToast__messageContainer_accessor_storage.set(this, __runInitializers(this, __messageContainer_initializers, void 0));
            _SdsNotificationToast__renderToggle_accessor_storage.set(this, (__runInitializers(this, __messageContainer_extraInitializers), __runInitializers(this, __renderToggle_initializers, false)));
            _SdsNotificationToast__bodyOverflows_accessor_storage.set(this, (__runInitializers(this, __renderToggle_extraInitializers), __runInitializers(this, __bodyOverflows_initializers, void 0)));
            _SdsNotificationToast__footerSlot_accessor_storage.set(this, (__runInitializers(this, __bodyOverflows_extraInitializers), __runInitializers(this, __footerSlot_initializers, void 0)));
            this.contentSlotHeight = __runInitializers(this, __footerSlot_extraInitializers);
        }
        /**
         * The date or timestamp associated with this notification.
         * Typically used to display when the notification was generated or received.
         *
         * @attr {string} date - Date or timestamp of the notification.
         */
        get date() { return __classPrivateFieldGet(this, _SdsNotificationToast_date_accessor_storage, "f"); }
        set date(value) { __classPrivateFieldSet(this, _SdsNotificationToast_date_accessor_storage, value, "f"); }
        /**
         * The type of this notification, determining its visual style and purpose.
         * Possible values include:
         * - `'default'`: Standard notification style.
         * - `'info'`: Provides informational messages.
         * - `'success'`: Conveys a success message.
         * - `'warning'`: Highlights a warning message.
         * - `'error'`: Displays an error message.
         *
         * Defaults to `'info'`.
         *
         * @attr {string} type - Type of the notification.
         */
        get type() { return __classPrivateFieldGet(this, _SdsNotificationToast_type_accessor_storage, "f"); }
        set type(value) { __classPrivateFieldSet(this, _SdsNotificationToast_type_accessor_storage, value, "f"); }
        /**
         * The duration, in milliseconds, for which the notification will be displayed.
         * A value of `0` or undefined keeps the notification open until dismissed.
         *
         * @attr {number} timeout - Display duration of the notification.
         */
        get timeout() { return __classPrivateFieldGet(this, _SdsNotificationToast_timeout_accessor_storage, "f"); }
        set timeout(value) { __classPrivateFieldSet(this, _SdsNotificationToast_timeout_accessor_storage, value, "f"); }
        get _messageContainer() { return __classPrivateFieldGet(this, _SdsNotificationToast__messageContainer_accessor_storage, "f"); }
        set _messageContainer(value) { __classPrivateFieldSet(this, _SdsNotificationToast__messageContainer_accessor_storage, value, "f"); }
        get _renderToggle() { return __classPrivateFieldGet(this, _SdsNotificationToast__renderToggle_accessor_storage, "f"); }
        set _renderToggle(value) { __classPrivateFieldSet(this, _SdsNotificationToast__renderToggle_accessor_storage, value, "f"); }
        get _bodyOverflows() { return __classPrivateFieldGet(this, _SdsNotificationToast__bodyOverflows_accessor_storage, "f"); }
        set _bodyOverflows(value) { __classPrivateFieldSet(this, _SdsNotificationToast__bodyOverflows_accessor_storage, value, "f"); }
        get _footerSlot() { return __classPrivateFieldGet(this, _SdsNotificationToast__footerSlot_accessor_storage, "f"); }
        set _footerSlot(value) { __classPrivateFieldSet(this, _SdsNotificationToast__footerSlot_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="${this.getClasses()}">
                <div class="sds-notification-toast__header">
                    <div class="sds-notification-toast__title">${this.heading}</div>
                    <sds-button
                        type="tertiary"
                        size="lg"
                        label=""
                        icon="close"
                        @click="${() => this.closeToast()}"
                    ></sds-button>
                </div>
                <div class="sds-notification-toast__body">
                    <div id="message-container" class="sds-notification-toast__message">
                        <slot
                            @slotchange=${() => this.handleBodySlotChange()
                .then()
                .catch(err => console.error(err))}
                            name="text"
                        ></slot>
                        <slot
                            @slotchange=${() => this.handleBodySlotChange()
                .then()
                .catch(err => console.error(err))}
                            name="content"
                        ></slot>
                    </div>
                    ${this.renderToggle()}
                </div>
                <div class="sds-notification-toast__footer">
                    ${this.renderDate()} ${this.renderActionsContainer()}
                </div>
            </div>
        `;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        async firstUpdated() {
            await this.updateComplete;
            this.isExpanded = false;
            if (this.type === 'info' || this.type === 'success') {
                this.setCloseTimeout();
            }
            else if (this.type === 'default') {
                this.expandContainer();
            }
        }
        async updated() {
            await this.setBodyOverflows();
        }
        collapseContainer() {
            this.removeBorderStyle();
            super.collapse(this._messageContainer, 'sds-notification-toast__message--large-height');
            this.requestUpdate();
        }
        expandContainer() {
            super.expand(this._messageContainer, 'sds-notification-toast__message--large-height');
            this.requestUpdate();
        }
        close() {
            this.remove();
        }
        getFooterContent() {
            return this._footerSlot;
        }
        renderDate() {
            if (this.date) {
                return html ` <div class="sds-notification-toast__date">${this.date}</div> `;
            }
        }
        async setBodyOverflows() {
            if (this.getContentSlot()[0]) {
                if (this.type === 'default') {
                    this._bodyOverflows =
                        (await this.calculateBodyOverflows(this.getContentSlot()[0], this._messageContainer)) && this.contentSlotHeight > this._messageContainer.getBoundingClientRect().height;
                }
                else {
                    this._bodyOverflows = await this.calculateBodyOverflows(this.getContentSlot()[0], this._messageContainer);
                }
            }
        }
        async handleBodySlotChange() {
            var _a;
            if (this.type === 'default') {
                this.contentSlotHeight = ((_a = this.getContentSlot()[0]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || 0;
            }
            await this.setBodyOverflows();
            if (this.type !== 'default') {
                this.setRenderToggle();
            }
        }
        setRenderToggle() {
            if (this._bodyOverflows) {
                this._renderToggle = true;
            }
        }
        calculateToastMessageLength() {
            return this.getContentSlot().reduce((length, slot) => length + slot.innerText.trim().length, 0);
        }
        setCloseTimeout() {
            const timeoutDuration = this.timeout || Math.min(Math.max(this.calculateToastMessageLength() * 50, 2000), 7000);
            this._timer = setTimeout(() => this.closeToast(), timeoutDuration);
        }
        getButtonTemplate(type, label, handler) {
            return html ` <sds-button
            type=${type}
            label="${label}"
            class="sds-notification-toast__btn"
            @click="${() => handler()}"
        ></sds-button>`;
        }
        renderToggle() {
            if (this._renderToggle) {
                if (this.isExpanded) {
                    return this.getButtonTemplate('tertiary', 'Show Less', () => this.toggleBodySize());
                }
                else {
                    return this.getButtonTemplate('tertiary', 'Show More', () => this.toggleBodySize());
                }
            }
        }
        isViewDetailsNeeded() {
            return this.isExpanded && this._bodyOverflows;
        }
        renderViewDetails() {
            if (this.isViewDetailsNeeded()) {
                this.addBorderStyle();
                return this.getButtonTemplate('secondary', 'View Details', () => this.openDialog());
            }
            else {
                this.removeBorderStyle();
            }
        }
        addBorderStyle() {
            this._messageContainer.classList.add('sds-notification-toast__message--with-border');
        }
        removeBorderStyle() {
            if (this._messageContainer &&
                this._messageContainer.classList.contains('sds-notification-toast__message--with-border')) {
                this._messageContainer.classList.remove('sds-notification-toast__message--with-border');
            }
        }
        areActionsNeeded() {
            return (this._renderToggle && this.isExpanded) || !this._renderToggle;
        }
        renderActionsContainer() {
            if (this.isViewDetailsNeeded() ||
                (this.getFooterContent().length !== 0 && this.areActionsNeeded())) {
                return html ` <div class="sds-notification-toast__actions">
                ${this.renderViewDetails()} ${this.renderActions()}
            </div>`;
            }
            else {
                this.removeBorderStyle();
                return html `${this.renderActions()}`;
            }
        }
        handleActionsSlotChange() {
            if (this.areActionsNeeded()) {
                this.requestUpdate();
            }
        }
        renderActions() {
            if (!this._renderToggle) {
                return html `
                <slot @slotchange="${() => this.handleActionsSlotChange()}" name="footer"></slot>
            `;
            }
            else if (this.isExpanded) {
                return html `
                <slot @slotchange="${() => this.handleActionsSlotChange()}" name="footer"></slot>
            `;
            }
        }
        openDialog() {
            const sdsModal = document.body.querySelector('sds-modal');
            if (!sdsModal) {
                render(this.getDialogTemplate(), document.body);
            }
            else {
                this.replaceExistingDialog(sdsModal);
            }
            this.closeToast();
        }
        replaceExistingDialog(sdsModal) {
            sdsModal.remove();
            sdsModal = document.createElement('sds-modal');
            const modalContainer = document.createElement('div');
            modalContainer.setAttribute('slot', 'content');
            sdsModal.appendChild(modalContainer);
            sdsModal.setAttribute('title', this.heading);
            sdsModal.setAttribute('open', '');
            render(this.renderModalContent(), modalContainer);
            render(this.getCancelActionTemplate(), sdsModal);
            document.body.append(sdsModal);
        }
        getCancelActionTemplate() {
            return html `
            <sds-button
                slot="secondary-action"
                label="${translate('sds.notification_toast.cancel')}"
                type="secondary"
                size="lg"
                @click="${() => { var _a; return (_a = document.body.querySelector('sds-modal')) === null || _a === void 0 ? void 0 : _a.removeAttribute('open'); }}"
            ></sds-button>
        `;
        }
        getDialogTemplate() {
            return html ` <sds-modal open="" title="${this.heading}" size="sm">
            <div slot="content">${this.renderModalContent()}</div>
            ${this.getCancelActionTemplate()}
        </sds-modal>`;
        }
        renderModalContent() {
            return html `
            <div class="sds-notification-toast__body">
                <div class="sds-notification-toast__message" id="message-container">
                    ${this._textSlot} ${this._contentSlot}
                </div>
            </div>
            <div class="sds-notification-toast__footer">${this.getFooterContent()}</div>
        `;
        }
        closeToast() {
            if (this._timer) {
                clearTimeout(this._timer);
            }
            this.dispatchEvent(new CustomEvent(SdsNotificationToast.CLOSED_EVENT, {
                bubbles: false,
                composed: false,
            }));
            this.close();
        }
        getClasses() {
            return classMap({
                'sds-notification-toast': true,
                'sds-notification-toast--default': this.type == 'default',
                'sds-notification-toast--info': this.type == 'info',
                'sds-notification-toast--success': this.type == 'success',
                'sds-notification-toast--warning': this.type == 'warning',
                'sds-notification-toast--error': this.type == 'error',
            });
        }
    };
    _SdsNotificationToast_date_accessor_storage = new WeakMap();
    _SdsNotificationToast_type_accessor_storage = new WeakMap();
    _SdsNotificationToast_timeout_accessor_storage = new WeakMap();
    _SdsNotificationToast__messageContainer_accessor_storage = new WeakMap();
    _SdsNotificationToast__renderToggle_accessor_storage = new WeakMap();
    _SdsNotificationToast__bodyOverflows_accessor_storage = new WeakMap();
    _SdsNotificationToast__footerSlot_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsNotificationToast");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _date_decorators = [property({ type: String })];
        _type_decorators = [property({ type: String })];
        _timeout_decorators = [property({ type: Number })];
        __messageContainer_decorators = [query('#message-container')];
        __renderToggle_decorators = [state()];
        __bodyOverflows_decorators = [state()];
        __footerSlot_decorators = [queryAssignedElements({ slot: 'footer' })];
        __esDecorate(_classThis, null, _date_decorators, { kind: "accessor", name: "date", static: false, private: false, access: { has: obj => "date" in obj, get: obj => obj.date, set: (obj, value) => { obj.date = value; } }, metadata: _metadata }, _date_initializers, _date_extraInitializers);
        __esDecorate(_classThis, null, _type_decorators, { kind: "accessor", name: "type", static: false, private: false, access: { has: obj => "type" in obj, get: obj => obj.type, set: (obj, value) => { obj.type = value; } }, metadata: _metadata }, _type_initializers, _type_extraInitializers);
        __esDecorate(_classThis, null, _timeout_decorators, { kind: "accessor", name: "timeout", static: false, private: false, access: { has: obj => "timeout" in obj, get: obj => obj.timeout, set: (obj, value) => { obj.timeout = value; } }, metadata: _metadata }, _timeout_initializers, _timeout_extraInitializers);
        __esDecorate(_classThis, null, __messageContainer_decorators, { kind: "accessor", name: "_messageContainer", static: false, private: false, access: { has: obj => "_messageContainer" in obj, get: obj => obj._messageContainer, set: (obj, value) => { obj._messageContainer = value; } }, metadata: _metadata }, __messageContainer_initializers, __messageContainer_extraInitializers);
        __esDecorate(_classThis, null, __renderToggle_decorators, { kind: "accessor", name: "_renderToggle", static: false, private: false, access: { has: obj => "_renderToggle" in obj, get: obj => obj._renderToggle, set: (obj, value) => { obj._renderToggle = value; } }, metadata: _metadata }, __renderToggle_initializers, __renderToggle_extraInitializers);
        __esDecorate(_classThis, null, __bodyOverflows_decorators, { kind: "accessor", name: "_bodyOverflows", static: false, private: false, access: { has: obj => "_bodyOverflows" in obj, get: obj => obj._bodyOverflows, set: (obj, value) => { obj._bodyOverflows = value; } }, metadata: _metadata }, __bodyOverflows_initializers, __bodyOverflows_extraInitializers);
        __esDecorate(_classThis, null, __footerSlot_decorators, { kind: "accessor", name: "_footerSlot", static: false, private: false, access: { has: obj => "_footerSlot" in obj, get: obj => obj._footerSlot, set: (obj, value) => { obj._footerSlot = value; } }, metadata: _metadata }, __footerSlot_initializers, __footerSlot_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsNotificationToast = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.CLOSED_EVENT = 'sds.toast.closed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsNotificationToast = _classThis;
})();
export { SdsNotificationToast };
